import React from 'react'

import MetricsStatusOverview from 'components_new/organisms/MetricsStatusOverview'
import MetricsTableHero from 'components_new/organisms/MetricsTableHero'
import MetricsTable from 'components_new/organisms/MetricsTable'

import PageLayout from 'components_new/templates/PageLayout'

import { useHistory } from 'react-router-dom'
import { addRef } from 'utils/queryHandler'
import { Context } from 'types/GlobalUserEvents'
import { useMetricCategories } from 'redux/hooks/Categories'
import { useAvailableMetrics } from 'components_new/organisms/MetricsTable/utils'
import { useMetrics } from 'redux/hooks/Metrics'
import { useTranslation } from 'language/translator'
import { useQuery } from 'utils/hooks'

const Metrics = () => {
  const history = useHistory()
  const categories = useMetricCategories()
  const { lang, t } = useTranslation()

  const [metrics] = useMetrics()
  const availableMetrics = useAvailableMetrics(metrics, true, null)

  const { query, setQuery } = useQuery()

  const category = query['category'] || null
  const search = query['search'] || null
  const status = query['status'] || null
  const subcategory = query['subcategory'] || null

  return (
    <PageLayout
      content={{
        hero: (
          <MetricsTableHero
            category={category}
            debounceSearch={true}
            subcategory={subcategory}
            search={search}
            setSearch={(value) => setQuery({ search: value })}
            setCategory={(value) =>
              setQuery({ category: value, subcategory: null })
            }
            setSubcategory={(value) => setQuery({ subcategory: value })}
          />
        )
      }}
      rightSidebar={{
        content: (
          <MetricsStatusOverview
            metrics={availableMetrics}
            setStatus={(value) => setQuery({ status: value })}
            status={status}
            sx={{ mt: 1 }}
          />
        ),
        size: 'small'
      }}
      topbar={{
        breadcrumbs: [
          {
            href: '/metrics',
            icon: { name: 'Metrics' },
            title: t('metrics', 'metrics')
          },
          ...(category
            ? [
                {
                  href: '/metrics',
                  icon: { name: 'Folder' as const },
                  search: `?category=${category}`,
                  title: categories[category]?.title[lang]
                }
              ]
            : [])
        ]
      }}
      variant="static"
    >
      <MetricsTable
        category={category}
        status={status}
        subcategory={subcategory}
        displayInactiveMetrics={true}
        onClickMetric={(id, defaultVariant) =>
          history.push(
            addRef(
              `/metrics/${id}?variant=${defaultVariant}`,
              Context.FROM_METRICS
            )
          )
        }
        search={search}
      />
    </PageLayout>
  )
}

export default Metrics
